export default "__VITE_ASSET__DVt$mTEC__"